import { render } from "./ViewImagesStatisch.vue?vue&type=template&id=62535f42"
import script from "./ViewImagesStatisch.vue?vue&type=script&lang=js"
export * from "./ViewImagesStatisch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__